<template>
  <v-container class="pa-2" fluid grid-list-sm >
    <h1>{{info.lesson_name}}</h1>

      <v-list>        
          <v-list-item v-for="(task,index) in info.task_list" :key="task.task_id">  
            <v-layout row wrap>
              <v-flex xs1> <v-layout justify-center>
                <v-icon>{{getTaskIcon(task.task_type_id)}}</v-icon>
                <v-icon v-if="task.islocked" color="primary">lock</v-icon>
                </v-layout></v-flex>
              <v-flex xs6 @click="editTask(task.task_type_id, task.task_id)" style="cursor:pointer"><span v-html=getIntro(task)></span></v-flex>
              <v-flex xs2>{{task.max_score}}</v-flex>
              <v-flex xs2>
                  <v-icon color="red" @click="showSolutions(task.task_id)">error</v-icon>

                  <v-icon @click="showTask(task.task_id)" >mdi-eye-outline</v-icon>
                  <v-icon @click="editTask(task.task_type_id, task.task_id)">mdi-pencil</v-icon>
                  <v-icon @click="cloneTask(task.task_id)">mdi-layers</v-icon>
                  <v-icon @click="tryDeleteTask(task.task_id)">mdi-delete</v-icon>
                  <v-icon v-if="index > 0" @click="moveTask(index, index-1)">mdi-arrow-up</v-icon>
                  <v-icon v-if="index < info.task_list.length-1" @click="moveTask(index, index+1)">mdi-arrow-down</v-icon>
              </v-flex> 
              <v-flex xs1> 
                <v-checkbox hide-details class="shrink mr-2 mt-0" v-model="selected" :value="task.task_id"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-list-item>  
      </v-list>
      <v-card>
        <v-card-title>
          </v-card-title>
          <v-card-text>  
            <v-layout wrap align-content-center>
              <v-flex xs1 > 
                Select type:
              </v-flex>

              <v-flex xs1 > 
                <v-btn large
                class="my-3"
                color="primary"
                @click="add_C">
                Content
                </v-btn> 
              </v-flex>
              <v-flex xs1>
                <v-menu
                  transition="slide-y-transition"
                  bottom
                  right
                >
                  <template v-slot:activator="{ on }">
                      <v-btn
                        large
                        class="my-3"
                        color="primary"
                        v-on="on"
                      >
                      Question
                      </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, i) in questions_list"
                      :key="i"
                      @click="add_Q(i)"
                    >
                      <v-list-item-title>{{ item }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-flex>    
              <v-flex xs1>
                <v-menu
                  transition="slide-y-transition"
                  bottom
                  right
                >
                  <template v-slot:activator="{ on }">
                      <v-btn
                        large
                        class="my-3"
                        color="primary"
                        v-on="on"
                      >
                      Programs
                      </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, i) in programs_list"
                      :key="i"
                      @click="add_P(i)"
                    >
                      <v-list-item-title>{{ item }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-flex>
              <v-flex xs2>

              </v-flex>
              <v-flex xs6>
              <v-card outlined v-if="chapters">
                <v-layout row wrap style="margin:5px">
                  <v-flex xs5 >
                    
                    <v-menu
                      transition="slide-y-transition"
                      bottom
                      right
                    >
                    <template v-slot:activator="{ on }">
                        <v-btn class="my-3" v-on="on" v-model="chapterText" style="width:100%">
                          {{chapterText}}
                          </v-btn>
                    </template>
                          <v-list>
                            <v-list-item v-for="(item, i) in chapters" :key="i"  
                              @click="selectedChapter = i; chapterText = chapters[selectedChapter].text.substring(0,20)+'...'; if (chapters[selectedChapter].lessons.length>0) lessonText = chapters[selectedChapter].lessons[0].text.substring(0,20)+'...'; else lessonText ='---';" >
                              <v-list-item-title>{{ item.text }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                    </v-menu>
                    
                  </v-flex>

                  <v-flex xs5 v-if="chapters[selectedChapter]">
                    <v-menu
                      transition="slide-y-transition"
                      bottom
                      right
                    >
                    <template v-slot:activator="{ on }">
                        <v-btn class="my-3" v-on="on" v-model="lessonText" style="width:100%">
                          {{lessonText}}
                          </v-btn>
                    </template>
                          <v-list>
                            <v-list-item v-for="(item, i) in chapters[selectedChapter].lessons" :key="i"  @click="selectedLesson = i; lessonText = chapters[selectedChapter].lessons[selectedLesson].text.substring(0,20)+'...'" >
                              <v-list-item-title>{{ item.text }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                    </v-menu>
                  </v-flex>
                  <v-flex xs2>
                    <v-btn color="primary" style="margin:12px" @click = processMicroLessons(1)>Move</v-btn>
                  </v-flex>
                  <v-flex xs10>

                  </v-flex>
                  <v-flex xs2>
                    <v-btn color="primary" style="margin:12px" @click = processMicroLessons(2)>Delete</v-btn>
                  </v-flex>
                </v-layout>
              </v-card>
              </v-flex>
          </v-layout>
          </v-card-text>  
      </v-card>

      <div v-if="dialogType >-1" style="position: absolute; top: 0; left: 0; height: 100%; width: 100%;">
      </div> 

      <dialog-drag v-if="dialogType >-1" persistent max-width="100" :options='dialog_options'>
        <p align="center"> 
            {{confirmText}}
        </p>
        <v-layout row justify-end>
          <v-btn style="margin-top:15px" outlined text @click="manipulateMicrolessons()">OK</v-btn>
          <v-btn style="margin-top:15px" outlined text @click="dialogType = -1">Cancel</v-btn>
        </v-layout>
      </dialog-drag>


  </v-container>
</template>

<script>
import axios from '../../../axios-auth.js'
import DialogDrag from 'vue-dialog-drag'
import * as brc from '../../../assets/breadcr.js'
import * as icn from '../../../assets/task_icons.js'

export default {
    data() {
        return {
            info : [],
            questions_list: ['Question type 2 (short answer)',
                            'Question type 3 (one correct)',
                            'Question type 4 (more correct)',
                            'Question type 5 (insert source code)',
                            'Question type 6 (drag&drop source code)',
                            'Question type 7 (lines reorder)'
                          ],
            programs_list:['Program type 8 (output program)',
                          'Program type 9 (class program)',
                          'Program type 10 (SQL)',
                          'Program type 11 (HTML, CSS)'
                          ],
            selected: [],
            selectedChapter: 0,
            selectedLesson: 0,
            chapterText : 'Select chapter...',
            lessonText : '---',
            chapters: null,
            dialogType: -1,
            taskForDelete: -1,
            dialog_options: {
              centered: parent,
              buttonPin: false,
              buttonClose: false
           },
           lesson_id: 0,
           courseID :0,
           confirmText: '-- empty --'

        }
    },
    mounted() {
        this.initData()
    },
    components: {
      DialogDrag
    },
    methods: {
      initData() {
        this.selected = []
        this.$store.commit('setFeedback', null)    
        this.lesson_id = this.$route.params.id
        axios.post('/get-tasks-in-lesson/' + this.lesson_id, null, this.$store.getters.getAxiosConfig )
        .then(res0 => {
            // set data to var
            this.info = res0.data 
            // chapters and lessons
            this.courseID = res0.data.course_id
            this.chapters = []
            axios.get('/course-preview/' + this.courseID, this.$store.getters.getAxiosConfig )
            .then(res => {
                this.$store.commit('setBreadCrumbs',brc.createAdminBC(
                        res.data.category.name, res.data.category.id,
                        res.data.area.name, res.data.area.id,                    
                        res.data.course.name, res.data.course.id,
                        res0.data.chapter.name, res0.data.chapter.id,
                        res0.data.lesson.name, res0.data.lesson.id                        
                    )) 
               
                for(let i = 0; i < res.data.chapterlist.length; i++) {
                  this.chapters.push( {
                                        text : res.data.chapterlist[i].name,
                                        value : i,
                                        id : res.data.chapterlist[i].chapter_id,
                                        lessons: []
                                      })
                  for(let j = 0; j < res.data.chapterlist[i].lessons.length; j++) {
                    this.chapters[i].lessons.push({
                                        text : res.data.chapterlist[i].lessons[j].lesson,
                                        value : j,
                                        id : res.data.chapterlist[i].lessons[j].lesson_id
                    })
                  }
                }
               
                this.chapterText = this.chapters[this.selectedChapter].text.substring(0,20)+'...'
                if (this.chapters[this.selectedChapter].lessons.length > 0)
                  this.lessonText = this.chapters[this.selectedChapter].lessons[this.selectedLesson].text.substring(0,20)+'...'
                else   
                  this.lessonText = '---'
                })
            .catch(error => {
                this.$store.commit('setFeedback', error)                
            })
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)
        })
      },
      //******************************************************************************* */
      getIcon(i) {
        return this.icon_list[i]
      },
      add_C() {
        this.$router.push({name:'admin_content', params: {lesson_id: this.$route.params.id, id: '0'}})        
      },
      add_Q(index) { 
        // write type to localstore
        localStorage.setItem('qtype', index+2)
        if (index < 0) this.$store.commit('setFeedback', null)  

        switch(index) {
            case 0:
            case 1:
            case 2:
              this.$router.push({name:'admin_type24', params: {lesson_id: this.lesson_id, id: '0'}}) 
              break;
            case 3:
            case 4:
              this.$router.push({name:'admin_type56', params: {lesson_id: this.lesson_id, id: '0'}}) 
              break;
            case 5:
              this.$router.push({name:'admin_type7', params: {lesson_id: this.lesson_id, id: '0'}}) 
              break;
        }        
      },
      add_P(index)  { 
        localStorage.setItem('qtype', index + 8)
        if (index < 0) this.$store.commit('setFeedback', null)  
          switch(index) {
            case 0:
            case 1:
            case 2:
              this.$router.push({name:'admin_type8', params: {course_id: this.courseID, lesson_id: this.lesson_id, id: '0'}}) 
              break;
            case 3:
              this.$router.push({name:'admin_type_11', params: {lesson_id: this.lesson_id, id: '0'}}) 
              break;
          }
      },
      showTask(id) {
          this.$router.push({name:'show_content', params: {id: id}})  
      },
      editTask(type, id) {
        switch(type) {
            case 1:
              this.$router.push({name:'admin_content', params: {lesson_id: this.$route.params.id, id: id}})  
              break;
            case 2:
            case 3:
            case 4:
              // options
              this.$router.push({name:'admin_type24', params: {lesson_id: this.lesson_id, id: id}}) 
              break;
            case 5:
            case 6:
              // code block
              this.$router.push({name:'admin_type56', params: {lesson_id: this.lesson_id, id: id}}) 
              break;
            case 7:
              // shuffle lines
              this.$router.push({name:'admin_type7', params: {lesson_id: this.lesson_id, id: id}}) 
              break;            
            case 8:
            case 9:
            case 10:
              // code 
              this.$router.push({name:'admin_type8', params: {course_id: this.courseID, lesson_id: this.lesson_id, id: id}}) 
              break;            
            case 11:
              // html
              this.$router.push({name:'admin_type_11', params: {lesson_id: this.lesson_id, id: id}}) 
              break;            
            default:
              // code block
          } 
      },
      tryDeleteTask(id_task) {
        this.taskForDelete = id_task
        this.confirmText = 'Do you want to delete 1 element?'
        this.dialogType = 3
      },      
      deleteTask() {
          axios.get('/delete-task/' + this.taskForDelete, this.$store.getters.getAxiosConfig )
          .then(() => {
              // set data to var
              this.initData()
          })
          .catch(error => {
            this.$store.commit('setFeedback', error)
          })
      },
      cloneTask(task_id) {
        const data = {
          task_id: task_id
        }
        
        axios.post('/task-clone', data, this.$store.getters.getAxiosConfig )
        .then(() => {
          // set data to var
          this.initData()
        })
          .catch(error => {
            this.$store.commit('setFeedback', error)
        })
      },
      moveTask(p1, p2) {
        const data = {
          task_id1: this.info.task_list[p1].task_id,
          task_order1: this.info.task_list[p1].task_order,
          task_id2: this.info.task_list[p2].task_id,
          task_order2: this.info.task_list[p2].task_order
        }
        
        axios.post('/task-change-order', data, this.$store.getters.getAxiosConfig )
        .then(() => {
          // set data to var
          this.initData()
        })
          .catch(error => {
            this.$store.commit('setFeedback', error)
        })
      },
      getIntro(task) {
        const myText = task.task_content
        if (task.task_type_id>=1 && task.task_type_id<8) {
          let start = myText.indexOf("<p>")
          var end = myText.indexOf("</p>")
          if (end - start > 250) end = myText.indexOf(" ",250)
          return myText.substring(start+3,end) + '...'
        } else {
          let e = myText.indexOf('"',10)
          return myText.substring(10,e)
        }

      },
      processMicroLessons(_type) {        
        if (this.selected.length == 0) return
        if (_type == 1) {
          if (this.lessonText == '---') return
          this.confirmText = 'Move ' + this.selected.length + ' element(s)?'
        }
        if (_type == 2) {
          this.confirmText = 'Delete ' + this.selected.length + ' element(s)?'
        }
        this.dialogType = _type
      },
      getTaskIcon(index) {
        return icn.getTaskIcon(index)
      },
      manipulateMicrolessons(){
        const my_process = this.dialogType
        this.dialogType = -1
        if (my_process == 3) { // delete one piece of ML
          this.deleteTask()
          return
        }

        var _changes = '('+this.selected[0]
        for (let i = 1; i < this.selected.length; i++) {
         _changes = _changes + ',' + this.selected[i]
        }
        _changes = _changes + ')'

        /********************* move */
        var _operation = 'move' // my_process is 1 
        var _newLesson = 0
        var _newChapter = 0
        if (my_process == 1) {
         _newLesson = this.chapters[this.selectedChapter].lessons[this.selectedLesson].id
         _newChapter = this.chapters[this.selectedChapter].id         
        }

        /********************* delete  */
        if (my_process == 2) { 
          _operation = 'delete' 
          _newLesson = 0
        }

        const data = {
          operation: _operation,
          newLesson : _newLesson,
          newChapter : _newChapter,
          changes : _changes
        }
        axios.post('/multiple-changes', data, this.$store.getters.getAxiosConfig )
          .then(() => {
            // set data to var
            this.initData()
          })
          .catch(error => {
            this.$store.commit('setFeedback', error)
        })
      },
      showSolutions(task_id) {
        this.$router.push({name:'show_solutions', params: {id: task_id}})  
      }
    }
}
</script>

<style src="vue-dialog-drag/dist/vue-dialog-drag.css"></style>

<style>


</style>